export const afterSalesOorderStatus = { 
  CREATE_ORDER: {
    nodeName: '创建',
    orderStatus:0,
  },
  DISPATCH_ORDER:{
    nodeName: '派单',
    orderStatus:1,
  },
  SIGN_FOR:{
    nodeName: '签收',
    orderStatus:2,
  },
  REPAIR:{
    nodeName: '维修',
    orderStatus:3,
  },
  CONFIRMATION_REPAIR:{
    nodeName: '维修确认',
    orderStatus:4,
  },
  REPAIR_REVIEW:{
    nodeName: '维修复核',
    orderStatus:5,
  },
  APPROVAL_CHECK:{
    nodeName: '归档审批',
    orderStatus:6,
  },
  COMPLETE_REPAIR:{
    nodeName: '完成',
    orderStatus:7,
  },
  MIDWAY_END:{
    nodeName: '中途结束',
    orderStatus:8,
  },
}